import { render } from "./DispatchField.vue?vue&type=template&id=fd5185aa&ts=true"
import script from "./DispatchField.vue?vue&type=script&lang=ts"
export * from "./DispatchField.vue?vue&type=script&lang=ts"

import "./DispatchField.vue?vue&type=style&index=0&id=fd5185aa&lang=scss"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__